import React from 'react';
import './payment-screen.scss';
import { usePaymentScreen } from './hooks/use-payment-screen';
import { LoadingSpinner, SVGS } from '@zonofi/zono-money-design-system';
import {
  CategoryButton,
  FallBackScreen,
  PaymentHeader,
  PaymentList,
} from '@zonofi/zono-money-whatsapp-stack';
import { PaymentStatusChips } from '../payment-status-chips/payment-status-chips';
import { FilterModal } from '@zonofi/seller-hub/components/filter/filter-modal';
import { FilterRoute } from '@zonofi/zono-money-store';
import { isEmpty } from 'lodash';
export const PaymentScreen: React.FC = () => {
  const {
    showSearch,
    setShowSearch,
    searchKey,
    setSearchKey,
    error,
    isLoading,
    lastItemRef,
    onScroll,
    statusChips,
    appliedStatusFilter,
    filterPage,
    setFilterPage,
    openFiltersDrawer,
    appliedDateRange,
    applyNewDateRange,
    appliedFilters,
    paymentsData,
    isEndOfList,
    pageNo,
    getPaymentsListAPIResponse,
  } = usePaymentScreen();

  return (
    <div className="payment-screen">
      <div className="payment-screen-header-category-container">
        <PaymentHeader
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          showCategory={true}
          appliedDateRange={appliedDateRange}
          applyNewDateRange={applyNewDateRange}
          openFiltersDrawer={openFiltersDrawer}
        />
      </div>
      {error?.show && (
        <div className="payment-screen-error-section font-primary">
          <h2 className=" font-primary">{error?.code}</h2>
          <span className="font-primary-semibold">{error?.message}</span>
        </div>
      )}
      <PaymentStatusChips
        selectedStatus={appliedStatusFilter}
        statusChips={statusChips}
        appliedFilters={appliedFilters}
      />
      {isLoading ? (
        <div className="payment-screen-loading">
          <LoadingSpinner />
        </div>
      ) : isEmpty(paymentsData) ? (
        <FallBackScreen
          image={SVGS.PaymentEmptyState}
          message="No Payments Found"
          description=""
          contentStyle={{
            justifyContent: 'center',
          }}
        />
      ) : paymentsData?.length > 0 ? (
        <>
          <div className="payment-list" onTouchMove={onScroll}>
            <PaymentList paymentList={paymentsData} />
            <div
              ref={lastItemRef}
              className="lastItemRef"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
          {!isEndOfList &&
            pageNo !== 1 &&
            getPaymentsListAPIResponse?.isFetching && (
              <div className="payment-screen-list-loading font-primary">
                <LoadingSpinner size={'small'} />
              </div>
            )}
        </>
      ) : (
        !error?.show && (
          <div className="payment-screen-loading">
            <LoadingSpinner />
          </div>
        )
      )}
      {/* main section end  */}
      <FilterModal
        open={!!filterPage}
        onClose={() => {
          setFilterPage('');
        }}
        route={FilterRoute.Payment}
        filterPage={filterPage}
        dateSelectionMode="dateRange"
      />
    </div>
  );
};
